/*
 *
 * DivisionsImport constants
 *
 */

export const GET_TEMPLATE_DIVISION_WATCHER =
  "app/DivisionsImport/GET_TEMPLATE_DIVISION_WATCHER"
export const GET_TEMPLATE_FAILED = "app/DivisionsImport/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS = "app/DivisionsImport/GET_TEMPLATE_SUCCESS"

export const UPLOAD_TEMPLATE_WATCHER =
  "app/DivisionsImport/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS =
  "app/DivisionsImport/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED =
  "app/DivisionsImport/UPLOAD_TEMPLATE_FAILED"
